import { baseTheme_default } from './chunk-YD2QUJX6.mjs';
import { __spreadProps, __spreadValues } from './chunk-D6FLC3TD.mjs';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

var theme = createTheme(__spreadProps(__spreadValues({}, baseTheme_default), {
  components: {
    MuiPaper: {
      defaultProps: {
        elevation: 6
      }
    }
  }
}));
var theme_default = responsiveFontSizes(theme);

export { theme_default };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-AORA22KZ.mjs.map